var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.913 6.286a3.15 3.15 0 0 1 3.174 0l8 4.667a3.15 3.15 0 0 1 1.563 2.72v10.703a3.15 3.15 0 0 1-3.15 3.15h-3v-10.15a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v10.15h-3a3.15 3.15 0 0 1-3.15-3.15V13.674a3.15 3.15 0 0 1 1.563-2.721l8-4.667Zm4.03-1.468a4.85 4.85 0 0 0-4.887 0l-8 4.667a4.85 4.85 0 0 0-2.406 4.189v10.702a4.85 4.85 0 0 0 4.85 4.85h16a4.85 4.85 0 0 0 4.85-4.85V13.674a4.85 4.85 0 0 0-2.406-4.19l-8-4.666Z"
  })));
};
export default SvgHome;